import Card from "components/Card/Card";
import { ControlledInput } from "components/Card/ControlledInput";
import { MaskedInput, TextInput } from "components/inputs";
import ControlledSelect from "components/inputs/Select/ControlledSelect";
import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import type { ConstantTypes, TinType } from "types/DataTypes";

type RRETinRecoveryAgentSectionProps = {
  control: Control<TinType>;
  getValues: UseFormGetValues<TinType>;
  setValue: UseFormSetValue<TinType>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
  constants?: ConstantTypes;
};

const RRETinRecoveryAgentSection = ({
  control,
  handleFieldChange,
  constants,
}: RRETinRecoveryAgentSectionProps) => {
  return (
    <Card heading="Recovery Agent Details">
      <ControlledInput
        control={control}
        name="recovery_agent_mailing_name"
        label="Mailing Name"
        placeholder="Enter Mailing Name"
        errors={{}}
        maxLength={70}
        onSave={(value) =>
          handleFieldChange("recovery_agent_mailing_name", value)
        }
        componentType={TextInput}
      />

      <ControlledInput
        control={control}
        name="recovery_agent_mailing_address_line1"
        label="Address Line 1"
        placeholder="Enter Address Line 1"
        errors={{}}
        maxLength={50}
        onSave={(value) =>
          handleFieldChange("recovery_agent_mailing_address_line1", value)
        }
        componentType={TextInput}
      />

      <ControlledInput
        control={control}
        name="recovery_agent_mailing_address_line2"
        label="Address Line 2"
        placeholder="Enter Address Line 2"
        errors={{}}
        maxLength={50}
        onSave={(value) =>
          handleFieldChange("recovery_agent_mailing_address_line2", value)
        }
        componentType={TextInput}
      />

      <ControlledInput
        control={control}
        name="recovery_agent_city"
        label="City"
        placeholder="Enter City"
        errors={{}}
        maxLength={30}
        onSave={(value) => handleFieldChange("recovery_agent_city", value)}
        componentType={TextInput}
      />

      <ControlledSelect
        control={control}
        name="recovery_agent_state"
        label="State"
        placeholder="Select State"
        errors={{}}
        options={constants?.STATES || []}
        onSave={(option) =>
          handleFieldChange("recovery_agent_state", option?.value)
        }
      />

      <ControlledInput
        control={control}
        name="recovery_agent_zipcode"
        label="Zip Code"
        placeholder="Enter Zip Code"
        errors={{}}
        onSave={(value) => handleFieldChange("recovery_agent_zipcode", value)}
        componentType={MaskedInput}
        mask="zipcode"
      />

      <ControlledInput
        control={control}
        name="recovery_agent_zip_plus_4"
        label="Zip+4"
        placeholder="Enter Zip+4"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("recovery_agent_zip_plus_4", value)
        }
        componentType={MaskedInput}
        maxLength={4}
        mask="zipcode-four"
      />

      <ControlledInput
        control={control}
        name="recovery_agent_tin"
        label="TIN"
        placeholder="Enter TIN"
        errors={{}}
        maxLength={9}
        mask="number"
        onSave={(value) => handleFieldChange("recovery_agent_tin", value)}
        componentType={TextInput}
      />

      <ControlledSelect
        control={control}
        name="recovery_agent_paperless_indicator"
        label="Paperless Indicator"
        placeholder="Select Paperless Indicator"
        errors={{}}
        options={constants?.PAPERLESS_INDICATOR || []}
        onSave={(option) =>
          handleFieldChange("recovery_agent_paperless_indicator", option?.value)
        }
      />
    </Card>
  );
};

export default RRETinRecoveryAgentSection;
